import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CopyToClipboardComponent } from './copy-to-clipboard/copy-to-clipboard.component';

const components = [
  CopyToClipboardComponent
];

@NgModule({
  declarations: [ ...components ],
  imports: [
    CommonModule
  ],
  exports: [ ...components ]
})
export class UtilsModule { }
